export interface InputState {
  throttle: number;
  brake: number;
  steer: number;
  handbrake: boolean;
  fire: boolean;
  fire2?: boolean;
  boost: boolean;
  dropWeapon: boolean;
  yaw: number;
}

export const EMPTY_INPUT: InputState = {
  throttle: 0,
  brake: 0,
  steer: 0,
  handbrake: false,
  fire: false,
  boost: false,
  dropWeapon: false,
  yaw: 0,
};

export type InputDeviceMode = "keyboard" | "gamepad" | "touch";
